export default __webpack_public_path__ + "static/media/logo-light.47208429.png";